/*=============================================== ImagePage ===============================================*/

import { Image } from "tsx-library-julseb"

import { ComponentsLayout } from "components"
import type { ItemType, PropsItemType } from "components"

import { commonProps, radiusObject } from "data"

const ImagePage = () => {
    const items: ItemType[] = [
        {
            title: "Auto height",
            content: (
                <Image
                    src="https://images.unsplash.com/photo-1643028468604-858ea2a9c111?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1932&q=80"
                    alt="Image"
                    borderRadius="xxl"
                />
            ),
            code: '<Image\n    src="https://images.unsplash.com/photo-1643028468604-858ea2a9c111?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1932&q=80"\n    alt="Image"\n    borderRadius="xxl"\n/>',
        },
        {
            title: "Fixed height with caption",
            content: (
                <Image
                    src="https://images.unsplash.com/photo-1643028468604-858ea2a9c111?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1932&q=80"
                    alt="Image"
                    height={300}
                    fit="cover"
                    caption="Caption"
                />
            ),
            code: '<Image\n    src="https://images.unsplash.com/photo-1643028468604-858ea2a9c111?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1932&q=80"\n    alt="Image"\n    height={300}\n    fit="cover"\n    caption="Caption"\n/>',
        },
    ]

    const propsItems: PropsItemType[] = [
        {
            subtitle: "src",
            type: "string",
            required: true,
        },
        {
            subtitle: "alt",
            type: "string",
            required: true,
        },
        {
            subtitle: "width",
            type: "number or string",
            default: "100%",
        },
        {
            subtitle: "height",
            type: "number or string",
            default: "auto",
        },
        {
            subtitle: "fit",
            type: "string",
            possible: commonProps.objectFit,
        },
        ...radiusObject(),
        "separator",
        {
            subtitle: "caption",
            type: "string or object",
        },
        {
            title: (
                <>
                    <code>caption</code> object
                </>
            ),
            subtitle: "text",
            intro: "This prop is required only if you want to add a caption.",
            type: "string",
        },
        {
            subtitle: "background",
            type: "string",
            possible: ["black", "white"],
            default: "black",
        },
        {
            subtitle: "asContainer",
            intro: "Changes the HTML tag for the Image container used with the caption",
            type: "string",
            possibleString: "Any HTML tag",
            default: "figcaption",
        },
    ]

    return <ComponentsLayout items={items} propsItems={propsItems} />
}

export default ImagePage
